const bankOpportunityDiscoveryTranslations = {
  en: {
    button: "Discover opportunities",
    title: "Automatic opportunity discovery",
    subtitle: "Search approved public bank and distressed-property sources. Every result requires review before import.",
    location: "Portugal, district or city",
    search: "Search approved sources",
    searching: "Searching…",
    provider: "Provider",
    results: "Results",
    noneFound: "No new matching opportunities were found.",
    notConfigured: "No web-search provider is configured.",
    externalWeb: "External / Web",
    unverified: "Unverified",
    source: "Source",
    reference: "Reference",
    viewOriginal: "View original",
    import: "Import to Bank & Distressed",
    imported: "Already imported",
    importSuccess: "Opportunity imported as an unverified draft.",
  },
  pt: {
    button: "Descobrir oportunidades",
    title: "Descoberta automática de oportunidades",
    subtitle: "Pesquise fontes públicas aprovadas de imóveis bancários e em situação especial. Cada resultado exige revisão antes da importação.",
    location: "Portugal, distrito ou cidade",
    search: "Pesquisar fontes aprovadas",
    searching: "A pesquisar…",
    provider: "Fornecedor",
    results: "Resultados",
    noneFound: "Não foram encontradas novas oportunidades correspondentes.",
    notConfigured: "Não está configurado nenhum fornecedor de pesquisa web.",
    externalWeb: "Externo / Web",
    unverified: "Não verificado",
    source: "Fonte",
    reference: "Referência",
    viewOriginal: "Ver anúncio original",
    import: "Importar para Banca e Distressed",
    imported: "Já importado",
    importSuccess: "Oportunidade importada como rascunho não verificado.",
  },
  zh: {
    button: "发现机会",
    title: "自动发现机会",
    subtitle: "搜索经批准的公开银行及困境房地产来源。每条结果在导入前均须审核。",
    location: "葡萄牙、地区或城市",
    search: "搜索批准的来源",
    searching: "搜索中…",
    provider: "搜索服务商",
    results: "结果",
    noneFound: "未发现新的匹配机会。",
    notConfigured: "尚未配置网络搜索服务商。",
    externalWeb: "外部 / 网络",
    unverified: "未核实",
    source: "来源",
    reference: "参考编号",
    viewOriginal: "查看原始信息",
    import: "导入银行及困境机会",
    imported: "已导入",
    importSuccess: "机会已作为未核实草稿导入。",
  },
  fr: {
    button: "Découvrir des opportunités",
    title: "Découverte automatique d’opportunités",
    subtitle: "Recherchez les sources publiques approuvées de biens bancaires et en difficulté. Chaque résultat doit être vérifié avant importation.",
    location: "Portugal, district ou ville",
    search: "Rechercher les sources approuvées",
    searching: "Recherche…",
    provider: "Fournisseur",
    results: "Résultats",
    noneFound: "Aucune nouvelle opportunité correspondante n’a été trouvée.",
    notConfigured: "Aucun fournisseur de recherche web n’est configuré.",
    externalWeb: "Externe / Web",
    unverified: "Non vérifié",
    source: "Source",
    reference: "Référence",
    viewOriginal: "Voir l’annonce originale",
    import: "Importer dans Banque & Distressed",
    imported: "Déjà importé",
    importSuccess: "Opportunité importée comme brouillon non vérifié.",
  },
  es: {
    button: "Descubrir oportunidades",
    title: "Descubrimiento automático de oportunidades",
    subtitle: "Busque fuentes públicas aprobadas de inmuebles bancarios y en dificultades. Cada resultado debe revisarse antes de importarlo.",
    location: "Portugal, distrito o ciudad",
    search: "Buscar fuentes aprobadas",
    searching: "Buscando…",
    provider: "Proveedor",
    results: "Resultados",
    noneFound: "No se encontraron nuevas oportunidades coincidentes.",
    notConfigured: "No hay ningún proveedor de búsqueda web configurado.",
    externalWeb: "Externo / Web",
    unverified: "No verificado",
    source: "Fuente",
    reference: "Referencia",
    viewOriginal: "Ver anuncio original",
    import: "Importar a Banca y Distressed",
    imported: "Ya importado",
    importSuccess: "Oportunidad importada como borrador no verificado.",
  },
  de: {
    button: "Chancen entdecken",
    title: "Automatische Chancensuche",
    subtitle: "Durchsuchen Sie genehmigte öffentliche Quellen für Bank- und Notverkaufsimmobilien. Jedes Ergebnis muss vor dem Import geprüft werden.",
    location: "Portugal, Bezirk oder Stadt",
    search: "Genehmigte Quellen durchsuchen",
    searching: "Suche läuft…",
    provider: "Anbieter",
    results: "Ergebnisse",
    noneFound: "Keine neuen passenden Chancen gefunden.",
    notConfigured: "Es ist kein Websuchanbieter konfiguriert.",
    externalWeb: "Extern / Web",
    unverified: "Nicht verifiziert",
    source: "Quelle",
    reference: "Referenz",
    viewOriginal: "Originalangebot ansehen",
    import: "In Bank & Distressed importieren",
    imported: "Bereits importiert",
    importSuccess: "Chance als nicht verifizierter Entwurf importiert.",
  },
  it: {
    button: "Scopri opportunità",
    title: "Ricerca automatica delle opportunità",
    subtitle: "Cerca nelle fonti pubbliche approvate di immobili bancari e in difficoltà. Ogni risultato deve essere verificato prima dell’importazione.",
    location: "Portogallo, distretto o città",
    search: "Cerca fonti approvate",
    searching: "Ricerca in corso…",
    provider: "Fornitore",
    results: "Risultati",
    noneFound: "Non sono state trovate nuove opportunità corrispondenti.",
    notConfigured: "Nessun fornitore di ricerca web è configurato.",
    externalWeb: "Esterno / Web",
    unverified: "Non verificato",
    source: "Fonte",
    reference: "Riferimento",
    viewOriginal: "Visualizza annuncio originale",
    import: "Importa in Banca e Distressed",
    imported: "Già importato",
    importSuccess: "Opportunità importata come bozza non verificata.",
  },
  ru: {
    button: "Найти возможности",
    title: "Автоматический поиск возможностей",
    subtitle: "Поиск по утверждённым открытым источникам банковской и проблемной недвижимости. Каждый результат требует проверки перед импортом.",
    location: "Португалия, округ или город",
    search: "Искать в утверждённых источниках",
    searching: "Поиск…",
    provider: "Провайдер",
    results: "Результаты",
    noneFound: "Новых подходящих возможностей не найдено.",
    notConfigured: "Провайдер веб-поиска не настроен.",
    externalWeb: "Внешний источник / Интернет",
    unverified: "Не проверено",
    source: "Источник",
    reference: "Ссылка",
    viewOriginal: "Открыть оригинал",
    import: "Импортировать в Bank & Distressed",
    imported: "Уже импортировано",
    importSuccess: "Возможность импортирована как непроверенный черновик.",
  },
};

export default bankOpportunityDiscoveryTranslations;
